module.exports = __webpack_public_path__ + "img/Training_courses_icon_3.2b7155f0.svg";